import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import {
  YouTube as YouTubeIcon,
  X as XIcon,
  Instagram as InstagramIcon,
  LinkedIn as LinkedInIcon,
  Language as LanguageIcon,
} from '@mui/icons-material';
import { API_CONFIG } from '../../../config/api';

// Logos customizados
const ThreadsIcon = ({ size }) => (
  <svg viewBox="0 0 192 192" width={size} height={size} style={{ display: 'block' }}>
    <path fill="currentColor" d="M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z" />
  </svg>
);

const TikTokIcon = ({ size }) => (
  <svg viewBox="0 0 448 512" width={size} height={size} style={{ display: 'block' }}>
    <path fill="currentColor" d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z" />
  </svg>
);

const FacebookIcon = ({ size }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} style={{ display: 'block' }}>
    <path fill="currentColor" d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const PinterestIcon = ({ size }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} style={{ display: 'block' }}>
    <path fill="currentColor" d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 01.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z" />
  </svg>
);

/**
 * Favicon - Atomo para exibir o favicon do site
 * Exibe a imagem do favicon ou um ícone padrão caso não exista.
 */
const Favicon = ({ url, alt = 'Favicon', size = 24, className = '', mediaType, imageScale = 1, ...props }) => {
  const [error, setError] = useState(false);

  // Função para obter favicon a partir da url do site
  const getFaviconUrl = (url) => {
    if (!url) return '';
    try {
      const u = new URL(url);
      return `${u.origin}/favicon.ico`;
    } catch {
      return '';
    }
  };

  // Corrigir URLs de localhost para usar a API real (artigos salvos antes de API_URL estar configurado)
  let fixedUrl = url;
  if (url && url.includes('localhost:5000')) {
    // Substituir localhost pela URL da API real usando configuração centralizada
    // Remove o /api do final pois a URL completa já inclui /api
    const apiBaseUrl = API_CONFIG.BASE_URL.replace('/api', '');
    fixedUrl = url.replace('http://localhost:5000', apiBaseUrl);
  }

  // Se url já for um favicon direto, proxy ou CDN (YouTube, TikTok, Instagram), usa ela. Se for uma url de site, tenta /favicon.ico
  let faviconSrc = '';
  if (fixedUrl && (
    fixedUrl.match(/\.(ico|png|jpg|jpeg|svg)(\?|$)/i) ||  // Extensões de imagem (com ou sem query string)
    fixedUrl.includes('/api/proxy/') ||                    // Proxy interno
    fixedUrl.includes('yt3.ggpht.com') ||                  // YouTube CDN
    fixedUrl.includes('ytimg.com') ||                      // YouTube CDN alternativo
    fixedUrl.includes('pbs.twimg.com/profile_images') ||   // X/Twitter avatars
    fixedUrl.includes('tiktokcdn') ||                      // TikTok CDN
    fixedUrl.includes('cdninstagram') ||                   // Instagram CDN
    fixedUrl.includes('fbcdn.net') ||                      // Facebook/Instagram CDN
    fixedUrl.includes('scontent') ||                       // Instagram/Facebook scontent CDN
    fixedUrl.includes('instagram.com/static/') ||          // Instagram static images
    fixedUrl.includes('pinimg.com')                        // Pinterest CDN
  )) {
    // URL de imagem direta, proxy ou CDN - usar diretamente
    faviconSrc = fixedUrl;
  } else if (fixedUrl && fixedUrl.startsWith('http')) {
    // URL de site - tentar /favicon.ico
    faviconSrc = getFaviconUrl(fixedUrl);
  }

  // Função para obter ícone customizado baseado no mediaType
  const getCustomIcon = (mediaType, size) => {
    switch (mediaType) {
      case 'Threads':
        return <ThreadsIcon size={size} />;
      case 'TikTok':
        return <TikTokIcon size={size} />;
      case 'Facebook':
        return <FacebookIcon size={size} />;
      case 'Pinterest':
        return <PinterestIcon size={size} />;
      case 'YouTube':
        return <YouTubeIcon sx={{ fontSize: size }} />;
      case 'Twitter':
        return <XIcon sx={{ fontSize: size }} />;
      case 'Instagram':
        return <InstagramIcon sx={{ fontSize: size }} />;
      case 'LinkedIn':
        return <LinkedInIcon sx={{ fontSize: size }} />;
      default:
        return null;
    }
  };

  const customIcon = mediaType ? getCustomIcon(mediaType, size) : null;
  const isPlatformFallbackFavicon = Boolean(
    faviconSrc && (
      (mediaType === 'YouTube' && faviconSrc.includes('youtube.com/favicon.ico')) ||
      (mediaType === 'Twitter' && faviconSrc.includes('abs.twimg.com/favicons/twitter.ico')) ||
      (mediaType === 'Pinterest' && faviconSrc.includes('pinterest.com/favicon.ico'))
    )
  );
  const shouldUseImage = Boolean(faviconSrc && !error && !isPlatformFallbackFavicon);

  return (
    <Box
      component="span"
      className={`favicon-atom ${className}`}
      sx={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: shouldUseImage ? '4px' : customIcon ? '0%' : '50%',
        overflow: 'hidden',
        background: 'transparent',
        verticalAlign: 'middle',
        mr: 0.5
      }}
      {...props}
    >
      {shouldUseImage ? (
        <img
          src={faviconSrc}
          alt={alt}
          width={size}
          height={size}
          style={{
            display: 'block',
            width: size,
            height: size,
            objectFit: 'cover',
            transform: imageScale !== 1 ? `scale(${imageScale})` : undefined,
            transformOrigin: 'center'
          }}
          referrerPolicy="no-referrer"
          onError={() => setError(true)}
        />
      ) : customIcon ? (
        customIcon
      ) : (
        <Box component="span" sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: size,
          height: size,
          borderRadius: '50%',
          backgroundColor: 'rgba(128,128,128,0.18)',
        }}>
          <LanguageIcon sx={{ fontSize: size * 0.8, color: 'rgba(160,160,160,0.85)' }} />
        </Box>
      )}
    </Box>
  );
};

Favicon.propTypes = {
  url: PropTypes.string, // Pode ser a url do site ou do favicon direto
  alt: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string,
  mediaType: PropTypes.string, // Tipo de mídia para usar ícone customizado
  imageScale: PropTypes.number
};

export default Favicon; 
